var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTenantInvoices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_2102048_invoice_report_shopping_icon",
    "data-name": "2102048_invoice_report_shopping_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.434,
    height: 33.434,
    viewBox: "0 0 33.434 33.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(8.37 4.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8068",
    "data-name": "Path 8068",
    d: "M4.136,5.431H8.665L4.136.9Z",
    transform: "translate(7.751 -0.624)",
    fill: "white",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8069",
    "data-name": "Path 8069",
    d: "M13.2,5.848v-5H1.709v24.8l.665-.665h0a.2.2,0,0,1,.278,0l.938.938.937-.937h0a.2.2,0,0,1,.278,0l.938.938.937-.937h0a.2.2,0,0,1,.278,0l.938.938.937-.937h0a.2.2,0,0,1,.278,0l.938.938.937-.937h0a.2.2,0,0,1,.278,0l.938.938.937-.937h0a.2.2,0,0,1,.278,0l.938.938.937-.937h0a.2.2,0,0,1,.278,0l.938.938.937-.937h0a.2.2,0,0,1,.278,0l.666.666V6.045h-5a.2.2,0,0,1-.2-.2ZM9.633,8.3a.2.2,0,0,1,0,.393H4.022a.2.2,0,1,1,0-.393H9.633ZM4.022,11.742H9.633a.2.2,0,0,1,0,.393H4.022a.2.2,0,1,1,0-.393Zm0,3.447H9.633a.2.2,0,0,1,0,.393H4.022a.2.2,0,0,1,0-.393Zm0,3.447H9.633a.2.2,0,1,1,0,.393H4.022a.2.2,0,1,1,0-.393Zm-.2,3.643a.2.2,0,0,1,.2-.2H16.091a.2.2,0,1,1,0,.393H4.022a.2.2,0,0,1-.2-.2Zm9.094-3.447a.2.2,0,0,1,.2-.2h2.975a.2.2,0,1,1,0,.393H13.116a.2.2,0,0,1-.2-.2Zm0-3.447a.2.2,0,0,1,.2-.2h2.975a.2.2,0,0,1,0,.393H13.116a.2.2,0,0,1-.2-.2Zm0-3.447a.2.2,0,0,1,.2-.2h2.975a.2.2,0,0,1,0,.393H13.116a.2.2,0,0,1-.2-.2Zm0-3.447a.2.2,0,0,1,.2-.2h2.975a.2.2,0,0,1,0,.393H13.116a.2.2,0,0,1-.2-.2Z",
    transform: "translate(-1.709 -0.845)",
    fill: "white",
    fillRule: "evenodd"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1418",
    "data-name": "Rectangle 1418",
    width: 33.434,
    height: 33.434,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantInvoices);
export default __webpack_public_path__ + "static/media/tenant_invoices.23de4fb6a1fab72a3bfc8459a4b815d7.svg";
export { ForwardRef as ReactComponent };